

export const ErrorBox = ( { message }) => {
    return (
        <div className="boxError">
            <p className="text">{ message }</p>
        </div>
    )
}